import styled from 'styled-components';
import { Color, media } from '../../../theme';
export const DataTable = styled('table') `
  border-collapse: separate;
  width: 100%;
  border: 1px solid ${Color.GRAY_300};
  border-radius: 0.375rem;
  background: ${Color.WHITE};
  border-spacing: 0;
  overflow: hidden;

  ${media.down('sm') `
    /* Force table to not be like tables anymore */
    display: block;

    thead, tbody, th, tr {
      display: block;
    }
  `}
`;
//# sourceMappingURL=data-table.styles.js.map